const React = require('react');
const Availability = require('./availability.jsx').Availability;
const HeaderDetailsView = require('./header.details.jsx').HeaderDetailsView;

const FavoriteListItem = React.createClass({

    render: function() {
        return (
            <div className="large-white-box">
                <div>
                    <header className="layout-header">
                        <HeaderDetailsView {...this.props.favorite} />
                    </header>
                    <Availability {...this.props.favorite} />

                </div>

            </div>
        );
    }
});

exports.FavoriteListItem = FavoriteListItem;
